export const Path = {
    SIMULATION_TEMPLATE_FORMFIELDS: ['formFields'],
    SIMULATION_TEMPLATE_INITIALVALUES: ['initialValues']
};
